import React, { useEffect, useState } from 'react';
import FolderExternalChecksComponent from './Component';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import { FOLDER_EXTERNAL_CHECKS } from './queries/index';
import PropTypes from 'prop-types';

const FolderExternalChecksContainer = ({ documentId, siteId }) => {
  const [data, setData] = useState(null);

  const { loading, data: externalChecks } = useQueryWithErrorHandling(FOLDER_EXTERNAL_CHECKS, {
    variables: { documentId, siteId },
    cacheEviction: true
  });

  useEffect(() => {
    if (!loading && externalChecks) {
      const { folderExternalCheckList } = externalChecks;
      setData(folderExternalCheckList);
    }
  }, [loading, externalChecks]);

  return <FolderExternalChecksComponent checks={data} folderId={documentId} folderSiteId={siteId} />;
};

FolderExternalChecksContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired
};

export default FolderExternalChecksContainer;
